<template>
  <div
    class="tab-btn-container"
    :class="[spacingClass]"
    v-if="showSubmitButton"
  >
    <button
      :style="brandedSubmitBtnStyle"
      @click.stop="$emit('submit', $event)"
      class="tab-btn next submit"
      :class="{
        'tab-visible': tabsLength > 1,
        'w-100': layoutSetting?.spacing == 'largemargin',
      }"
      type="submit"
      id="submitBtn"
    >
      {{ settings?.btnCaption || 'Starten' }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'FormNavigationButtonsElement',
  props: {
    element: {
      type: Object,
      required: true,
    },
    tabStructure: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    tabIndex: {
      type: [Number, String],
      required: true,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    layoutSetting: {
      type: Object,
      default: () => ({}),
    },
    brandedSubmitBtnStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    tabsLength() {
      return this.tabStructure?.tabs?.length || 0;
    },
    showSubmitButton() {
      if (this.element?.type !== 'navButtons') {
        return false;
      }
      return this.tabIndex == this.tabsLength - 1 || this.tabsLength === 1;
    },
    spacingClass() {
      const spacing = this.layoutSetting?.spacing;
      if (spacing === 'fullwidth') return 'spacing-fullwidth';
      if (spacing === 'standard') return 'spacing-standard';
      if (spacing === 'largemargin') return 'spacing-large';
      return 'spacing-custom';
    },
  },
};
</script>

<style scoped>
.tab-btn-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  position: relative;
}

.tab-btn-container .tab-btn {
  width: 221px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 0.5px solid;
  cursor: pointer;
  font-family: 'OpenSans-Bold';
  font-size: 16px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -0.32px;
  position: relative;
  color: white;
  margin-top: 15px;
}

.tab-btn-container .tab-btn.next {
  color: #fff;
  border-color: #000;
  background: #000;
}

.tab-btn-container.spacing-fullwidth .tab-btn,
.tab-btn-container.spacing-standard .tab-btn {
  width: 383px;
}

.tab-btn-container.spacing-large .submit.tab-visible {
  width: 221px;
}
</style>
